import { PRIVATE_ADMIN_LIST_JOBPOSITIONS } from "../Constants/PathsConstant";
import TableJobPositionView from "../Views/TableJobPositionView";

export const JobPositionRouter = [
  {
    path: PRIVATE_ADMIN_LIST_JOBPOSITIONS,
    element: <TableJobPositionView />,
    children: []
  }
];
